<div class="modal-header">
  <h4 class="modal-title pull-left">
    Add plan
  </h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
  </button>
</div>

<div class="modal-body">
  <form class="form-horizontal" #newPlanForm="ngForm">
    <div class="form-group">
      <label for="name" class="col-sm-3 control-label">Plan name</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" id="name" name="name" [(ngModel)]="activePlan.name" #name="ngModel" required>
        @if (name.invalid && name.touched) {
          <div class="form-error">
            @if (name.errors?.required) {
              <p>This field is required.</p>
            }
          </div>
        }
        @if (name.errors?.serverError) {
          <div class="form-error">
            <p>{{ name.errors.serverError }}</p>
          </div>
        }
      </div>
    </div>

    <div class="form-group">
      <label for="carrier_id" class="col-sm-3 control-label">Carrier name</label>
      <div class="col-sm-9">
        <select class="form-control" id="carrier_id" name="carrier_id" [(ngModel)]="activePlan.carrier_id" #carrierId="ngModel" required>
          @for (carrier of carrierOptions; track carrier) {
            <option [value]="carrier.id">
              {{ carrier.name }}
            </option>
          }
        </select>
        @if (carrierId.invalid && carrierId.touched) {
          <div class="form-error">
            @if (carrierId.errors?.required) {
              <p>This field is required.</p>
            }
          </div>
        }
        @if (carrierId.errors?.serverError) {
          <div class="form-error">
            <p>{{ carrierId.errors.serverError }}</p>
          </div>
        }
        <p><a (click)="openNewCarrierModal()">Add new carrier</a></p>
      </div>
    </div>

    <div class="form-group">
      <label for="authorization_contact" class="col-sm-3 control-label">Phone number</label>
      <div class="col-sm-9">
        <input type="text"
          class="form-control"
          id="authorization_contact"
          name="authorization_contact"
          pattern="[1-9]{1}[0-9]{9}"
          required
          #phoneNumber="ngModel"
          [(ngModel)]="activePlan.authorization_contact">
        @if (phoneNumber.invalid && phoneNumber.touched) {
          <div class="form-error">
            @if (phoneNumber.errors.required) {
              <p>This field is required.</p>
            }
            @if (phoneNumber.errors.pattern) {
              <p>Phone number is invalid.</p>
            }
          </div>
        }
        @if (phoneNumber.errors?.serverError) {
          <div class="form-error">
            <p>{{ phoneNumber.errors.serverError }}</p>
          </div>
        }
      </div>
    </div>

    <div class="form-group">
      <label for="insurance_categories" class="col-sm-3 control-label">Insurance category</label>
      <div class="col-sm-9">
        <angular2-multiselect
          id="insurance_categories"
          name="insurance_categories"
          [data]="insuranceCategoryOptions"
          [(ngModel)]="activePlan.insurance_categories"
          [ngModelOptions]="{standalone: true}"
          [settings]="{tagToBody: false}"
          >
          <c-item>
            <ng-template let-item="item">
              <label>{{item.itemName}}</label>
            </ng-template>
          </c-item>
        </angular2-multiselect>
      </div>
    </div>

    <div class="form-group">
      <label for="covered_vehicles" class="col-sm-3 control-label">Covered vehicle types</label>
      <div class="col-sm-9">
        <angular2-multiselect
          id="covered_vehicles"
          name="covered_vehicles"
          [data]="vehicleTypeOptions"
          [(ngModel)]="activePlan.covered_vehicles"
          [ngModelOptions]="{standalone: true}"
          [settings]="{tagToBody: false}"
          >
          <c-item>
            <ng-template let-item="item">
              <label>{{item.itemName}}</label>
            </ng-template>
          </c-item>
        </angular2-multiselect>
      </div>
    </div>

    <div class="form-group">
      <label for="auth_required" class="col-sm-3 control-label">Authorization Required</label>
      <div class="col-sm-9">
        <ui-switch
          id="auth_required"
          name="auth_required"
          [(ngModel)]="activePlan.auth_required">
        </ui-switch>
      </div>
    </div>

    <div class="form-group">
      <label for="brokered_transport" class="col-sm-3 control-label">Brokered transport</label>
      <div class="col-sm-9">
        <ui-switch
          id="brokered_transport"
          name="brokered_transport"
          [(ngModel)]="activePlan.brokered_transport">
        </ui-switch>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>
  <button type="button" class="btn btn-primary" [disabled]="!newPlanForm.form.valid" (click)="save()">Save</button>
</div>
